module.exports = __webpack_public_path__ + "img/gtg88Logo.88d103fd.png";